import React from 'react';
import HintContent from '../../Navigation/Help/HintContent';

const ResetFiltersHint = () => {
  return (
    <HintContent>
      <h3>Reset Filters</h3>
      <p>Removes all filters to display the full dataset list.</p>
    </HintContent>
  );
};

export default ResetFiltersHint;
